import "./Plans.css";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const plans = [
    { speed: "100", price: "₹999", popular: false },
    { speed: "75", price: "₹799", popular: false },
    { speed: "50", price: "₹699", popular: true },
    { speed: "40", price: "₹599", popular: false },
];

function Plans() {
    const navigate = useNavigate();

    const handleRequestCallback = () => {
        const formSection = document.getElementById("contactFormSection");
        if (formSection) {
            formSection.scrollIntoView({ behavior: "smooth" });
            formSection.classList.add("highlight-form");
            setTimeout(() => {
                formSection.classList.remove("highlight-form");
            }, 2000);
        }
    };

    return (
        <section className="plans-section">
            <h2 className="section-title">
                Explore our range of affordable home broad band plans
            </h2>

            <div className="plans-grid">
                {plans.map((plan, index) => (
                    <div
                        key={index}
                        className={`plan-card ${plan.popular ? "popular" : ""}`}
                    >
                        {plan.popular && (
                            <div className="popular-badge">MOST POPULAR</div>
                        )}

                        <div className="plan-speed">{plan.speed}<span style={{ fontSize: "1rem" }}>Mbps</span></div>
                        <p style={{ fontSize: "1rem", color: "#1e3a8a" }}>at just</p>
                        <div className="plan-price">
                            {plan.price}/
                            <span style={{ fontSize: "1rem" }}>month</span>
                        </div>

                        <button
                            className="plan-btn"
                            onClick={handleRequestCallback}
                        >
                            REQUEST CALLBACK
                        </button>
                    </div>
                ))}
            </div>

            {/* Explore More Plans Button */}
            <div className="explore-plans-wrapper">
                <button
                    className="explore-plans-btn"
                    onClick={() => navigate("/plans")}
                >
                    View All Plans & Duration Pricing <ArrowRight size={18} />
                </button>
            </div>
        </section>
    );
}

export default Plans;
